
import CentroCustoSelect from "@/components/CentroCustoSelect/CentroCustoSelect.vue";

const hoje = new Date();
const dataLocal = (data) => {
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const dia = String(data.getDate()).padStart(2, "0");
  return `${ano}-${mes}-${dia}`;
};

export default {
  name: "RelatorioCentroCusto",
  components: { CentroCustoSelect },
  props: {
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filtros: {
        data_inicial: dataLocal(new Date(hoje.getFullYear(), hoje.getMonth(), 1)),
        data_final: dataLocal(hoje),
        regime: "competencia",
        id_centro_custo: null,
        incluir_sem_centro: true,
        detalhado: true,
      },
      carregando: false,
      gerandoPdf: false,
      relatorio: null,
      abertos: {},
    };
  },
  methods: {
    periodoValido() {
      if (!this.filtros.data_inicial || !this.filtros.data_final) {
        this.$toast.warning("Informe as datas para gerar o relatório!");
        return false;
      }

      if (this.filtros.data_final < this.filtros.data_inicial) {
        this.$toast.warning("A data final deve ser igual ou posterior à data inicial!");
        return false;
      }

      return true;
    },
    async gerar() {
      if (!this.periodoValido()) return;

      this.carregando = true;
      try {
        const { data } = await this.$http.post("/relatorios/centros-custos", this.filtros);
        this.relatorio = data.data || data;
        this.abertos = {};
      } finally {
        this.carregando = false;
      }
    },
    async gerarPdf() {
      if (!this.periodoValido()) return;

      this.gerandoPdf = true;
      try {
        const { data } = await this.$http.post("/relatorios/centros-custos", {
          ...this.filtros,
          gerar_pdf: true,
        });

        if (!data.status) {
          this.$toast.warning(data.message || "Não há dados para gerar o relatório.");
          return;
        }

        this.$toast.success(
          data.message || "Solicitação do PDF realizada com sucesso!"
        );
      } finally {
        this.gerandoPdf = false;
      }
    },
    chave(grupo) {
      return grupo.id_centro_custo || "sem-centro";
    },
    alternar(grupo) {
      const chave = this.chave(grupo);
      this.$set(this.abertos, chave, !this.abertos[chave]);
    },
    moeda(valor) {
      return Number(valor || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    formatarData(data) {
      if (!data) return "-";
      return String(data).slice(0, 10).split("-").reverse().join("/");
    },
  },
};
